export function isMobile(clientId: string) {
  return ["mobile"].includes(clientId);
}
